<!-- 文本编辑+九宫格传图 -->
<template>
  <div class="edit-content">
    <textarea
      v-if="showText"
      :placeholder="placeholder"
      v-model="text"
    ></textarea>
    <!-- 
      @oversize  文件超过最大限制触发
     -->
    <van-uploader
      v-model="fileList"
      :after-read="afterRead"
      @delete="deleteImg"
      @oversize="$toast('文件最大支持5M')"
      :name="fileList.length"
      :max-size="1024 * 1024 * 5"
      :max-count="maxCount"
      :before-delete="checkUpload"
    >
    </van-uploader>
  </div>
</template>
<script>
// 工具栏配置
export default {
  name: "Editor",
  props: {
    placeholder: {
      type: String,
      default: "请输入您的答案"
    },
    showText: {
      type: Boolean,
      default: true
    },
    maxCount: {
      type: Number,
      default: 9
    },
    own_ref: {
      type: String
    }
  },
  data() {
    return {
      text: "", // 文本内容
      fileList: [], //本地上传图片list
      upload: [], //上传完后台返回的图片list
      up_img_num: 0 //正在上传的图片数量
    };
  },
  watch: {
    /**
     *  上传状态 2 上传中 1 已上传
     */
    up_img_num(val) {
      if (val == 0) {
        this.$emit("uploadState", 1);
      } else {
        this.$emit("uploadState", 2);
      }
    }
  },
  methods: {
    /**
     * 本地上传完触发
     */
    afterRead(file) {
      const formdata = new FormData();
      this.up_img_num++;
      // 多张图片file为Array类型
      if (Array.isArray(file)) {
        file.forEach(item => {
          formdata.append("file[]", item.file);
          formdata.append("width", "1000");
        });
        this.$http.post(`/api/app/public/images`, formdata).then(res => {
          res.forEach(item => {
            this.upload.push(item);
          });
          this.up_img_num--;
        });
      } else {
        // 如果为单张图片 file为Object类型
        formdata.append("file", file.file);
        formdata.append("width", "1000");
        this.$http.post(`/api/app/public/img`, formdata).then(res => {
          this.upload.push(res);
          this.up_img_num--;
        });
      }
      this.setIndex();
    },
    /**
     * 未完成上传不可删除任意图片
     */
    checkUpload() {
      if (this.up_img_num) {
        this.$toast("上传中，不可删除~");
        return false;
      } else {
        return true;
      }
    },
    /**
     * 删除图片
     */
    deleteImg(file) {
      this.upload.splice(file.index, 1);
    },
    /**
     * 图片list设置标记
     */
    setIndex() {
      this.fileList.forEach((item, index) => {
        item["index"] = index;
      });
    },
    // 返回用户的答案
    userAnwser() {
      let _this = this;
      return JSON.stringify({
        text: _this.text,
        img_list: _this.upload
      });
    },
    /**
     *  重置/赋值
     * @param {any} str_obj  { text: '', img_list: [] }, img_list: [ "imgsrc"] / [{path:"imgsrc"}]
     * */
    initEdit(str_obj) {
      let obj;
      if (str_obj) {
        if (typeof str_obj == "string") {
          obj = JSON.parse(str_obj);
        } else {
          obj = str_obj;
        }
      } else {
        obj = {
          text: "",
          img_list: []
        };
      }
      this.text = obj.text || "";
      if (obj.img_list.length) {
        obj.img_list.forEach((item, index) => {
          this.fileList.push({
            url: item.path || item,
            index
          });
        });
        this.upload = obj.img_list;
      } else {
        this.upload = [];
        this.fileList = [];
      }
    }
  }
};
</script>
<style lang="scss">
.edit-content {
  padding: 30px 30px;
  textarea {
    border: none;
    width: 100%;
    min-height: 200px;
    font-size: 30px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #222222;
    line-height: 44px;
    margin-bottom: 40px;
  }
  /deep/ .van-uploader__preview {
    .van-uploader__preview-image {
      width: 216px;
      height: 216px;
    }
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
  /deep/ .van-uploader__upload {
    width: 216px;
    height: 216px;
    margin: 0;
  }
}
</style>
